import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Project 1, Staging (project1/staging)
        </p>
      </header>
    </div>
  );
}

export default App;
